import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import StripePaymentComponent from './components/component';
import ReturnsApolloProvider from '../ApolloProvider';

export const mapStateToProps = ({ stripeWidget }) => ({
  stripeWidget,
});

const StyledErrors = styled.h3`
  margin: 1rem 0;
  color: #eb1c26;
  text-align: center;
`;

export const getStripeConfig = ({ id, stripeWidget }) =>
  stripeWidget.find((config) => config.id === id);

const StripeWidget = ({
  onClick,
  onSuccess,
  onError,
  confirmingCard,
  stripeWidget,
  id,
  aboveSubmitContent,
  disabled,
  hideSubmit,
}) => {
  if (!id || stripeWidget.length === 0) return null;
  const { serviceFee, completedPayment, errorMessage, paymentIntentSecret } = getStripeConfig({
    id,
    stripeWidget,
  });
  if (completedPayment || !serviceFee || !paymentIntentSecret) return null;
  if (errorMessage) {
    return (
      <StyledErrors className="card-errors" role="alert">
        {errorMessage}
      </StyledErrors>
    );
  }

  return (
    <ReturnsApolloProvider>
      <StripePaymentComponent
        {...{
          onClick,
          onSuccess,
          onError,
          confirmingCard,
          id,
          aboveSubmitContent,
          disabled,
          hideSubmit,
        }}
      />
    </ReturnsApolloProvider>
  );
};

StripeWidget.defaultProps = {
  onClick: () => {},
  onSuccess: () => {},
  onError: () => {},
  confirmingCard: false,
  stripeWidget: [],
  hideSubmit: false,
  aboveSubmitContent: null,
  disabled: false,
};

StripeWidget.propTypes = {
  onClick: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  confirmingCard: PropTypes.bool,
  stripeWidget: PropTypes.arrayOf(
    PropTypes.shape({
      paymentIntentSecret: PropTypes.string.isRequired,
      publishableKey: PropTypes.string.isRequired,
      completedPayment: PropTypes.bool.isRequired,
      serviceFee: PropTypes.number.isRequired,
      errorMessage: PropTypes.string.isRequired,
    }),
  ),
  id: PropTypes.string.isRequired,
  hideSubmit: PropTypes.bool,
  disabled: PropTypes.bool,
  aboveSubmitContent: PropTypes.node,
};

export default connect(mapStateToProps)(StripeWidget);
